import { useMatch } from "react-router-dom";
import { listAndDetailSamplesRoutes, listAndDetailSamplesRoutesCombined } from "../../ListAndDetailSamplesNavigation";
import { ListAndDetailSampleEditForm } from "../ListAndDetailSampleEditForm";

export const ListAndDetailSamplesCustomRenderEditPage = () => {

    const match = useMatch(listAndDetailSamplesRoutesCombined.customRender_editMatch);
    const cityTownCode = match?.params.cityTownCode;

    return (
        <ListAndDetailSampleEditForm
            listUrl={listAndDetailSamplesRoutes.customRender}
            cityTownCode={cityTownCode}
        />
    )
}
